export const scenes = [
  {
    title: "Coastal-Shore",
    preview: "/assets/scenery-backgrounds/coastal-shores-scenery.png",
    video: "https://cabanastorage.blob.core.windows.net/public/pods/videos/Coastal Shores.mp4",
  },
  {
    title: "Sunset-Lakes",
    preview: "/assets/scenery-backgrounds/sunset-lakes-scenery.png",
    video: "https://cabanastorage.blob.core.windows.net/public/pods/videos/Sunset Lakes.mp4",
  },
  {
    title: "Evergreen-Forest",
    preview: "/assets/scenery-backgrounds/evergreen-forest-scenery.png",
    video: "https://cabanastorage.blob.core.windows.net/public/pods/videos/Evergreen Forest.mp4",
  },
  {
    title: "Snowy-Tundra",
    preview: "/assets/scenery-backgrounds/snowy-tundra-scenery.png",
    video: "https://cabanastorage.blob.core.windows.net/public/pods/videos/Snowy Tundra.mp4",
  },
];

export const audios = [
  {
    id: "1",
    name: "Beholding Ambient",
    duration: "4 min",
    order: 1,
    image: "/assets/audio-backgrounds/Beholding_Ambient.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Beholding_Ambient.mp3",
  },
  {
    id: "2",
    name: "Energy Boost",
    duration: "5 min",
    order: 2,
    image: "/assets/audio-backgrounds/Energy_Boost.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Energy_Boost.mp3",
  },
  {
    id: "3",
    name: "Breath Exercise",
    duration: "4 min",
    order: 3,
    image: "/assets/audio-backgrounds/Breathing_Exercise.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Breathing_Exercise.mp3",
  },
  {
    id: "4",
    name: "Safe Place",
    duration: "3 min",
    order: 4,
    image: "/assets/audio-backgrounds/Safe_Place.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Safe_Place.mp3",
  },
  {
    id: "5",
    name: "Tension Relief",
    duration: "5 min",
    order: 5,
    image: "/assets/audio-backgrounds/Tension_Relief.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Tension_Relief.mp3",
  },
  {
    id: "6",
    name: "Affirmation Meditation",
    duration: "5 min",
    order: 6,
    image: "/assets/audio-backgrounds/Affirmation_Meditation.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Affirmation_Meditation.mp3",
  },
    {
    id: "7",
    name: "Boundary",
    duration: "5 min",
    order: 7,
    image: "/assets/audio-backgrounds/Boundary.png",
    audioUrl: "https://cabanastorage.blob.core.windows.net/public/pods/audios/Boundary.mp3",
  },
];

export const glasses = {
  // model: 'gadgets/models/glasses.glb',
  model: "gadgets/models/glasses-transformed.glb",
};

export const tablet = {
  model: "gadgets/models/tablet-transformed.glb",
};

export const quotes = [
  {
    quote: '"When you give joy to other people, you get more joy in return."',
    author: "Eleanor Roosevelt",
  },
  {
    quote:
      '"The best way to cheer yourself up is to try to cheer somebody else up."',
    author: "Mark Twain",
  },
  {
    quote:
      '"The best way to find yourself is to lose yourself in the service of others."',
    author: "Mahatma Gandhi",
  },
  {
    quote:
      '"Be the reason someone smiles. Be the reason someone feels loved and believes in the goodness in people."',
    author: "Roy T. Bennett",
  },
  {
    quote: "\"Nothing is impossible. The word itself says 'I'm possible!'\"",
    author: "Audrey Hepburn",
  },
  {
    quote:
      '"Keep your face always toward the sunshine, and shadows will fall behind you."',
    author: "Walt Whitman",
  },
  {
    quote:
      '"You define your own life. Don\'t let other people write your script."',
    author: "Oprah Winfrey",
  },
  {
    quote: '"Spread love everywhere you go."',
    author: "Mother Teresa",
  },
  {
    quote: '"Believe you can and you\'re halfway there."',
    author: "Theodore Roosevelt",
  },
  {
    quote: '"In a gentle way, you can shake the world."',
    author: "Mahatma Gandhi",
  },
  {
    quote: '"Try to be a rainbow in someone\'s cloud."',
    author: "Maya Angelou",
  },
];
